import React from 'react';
import { Chip, ChipsGroup } from 'fronton-react';
import { findTopCategoryData } from 'utils';
import { useLabelsContainer } from './hooks';

import { ChipStyle, ClearAllChipStyles, LabelsContainerWrapper } from './styles';

export const LabelsContainer = () => {
	const {
		selectedFilterItems,
		topCategories,
		labelHandler,
		clearAllLabelHandler,
	} = useLabelsContainer();

	if (!selectedFilterItems.length) {
		return null;
	}

	return (
		<LabelsContainerWrapper data-qa="labels-container-wrapper">
			<ChipsGroup>
				{selectedFilterItems.map(id => {
					const { topCategoryName } = findTopCategoryData(topCategories, id);
					const onDelete = () => labelHandler(id);

					return (
						<Chip
							variant="primary"
							text={topCategoryName}
							key={`chip-${id}`}
							className={ChipStyle}
							data-chipid={id}
							onDelete={onDelete}
						/>
					);
				})}
				<Chip
					variant="outline"
					text="Сбросить все"
					key="chip-clear-all"
					className={`${ChipStyle} ${ClearAllChipStyles}`}
					onDelete={clearAllLabelHandler}
				/>
			</ChipsGroup>
		</LabelsContainerWrapper>
	);
};
